// Components the Growth pages share: the status badges, an outbound link that
// only ever opens http(s), and the do-not-contact dialog.

import type { InquiryStatus, LeadStatus } from '@/api/types'
import { Badge, ExternalLinkIcon } from '@/components/ui'
import { INQUIRY_STATUS_LABELS, INQUIRY_STATUS_TONE, LEAD_STATUS_LABELS, LEAD_STATUS_TONE } from '@/lib/growth'

export function LeadStatusBadge({ status }: { status: LeadStatus }) {
  return <Badge tone={LEAD_STATUS_TONE[status]}>{LEAD_STATUS_LABELS[status]}</Badge>
}

export function InquiryStatusBadge({ status }: { status: InquiryStatus }) {
  return <Badge tone={INQUIRY_STATUS_TONE[status]}>{INQUIRY_STATUS_LABELS[status]}</Badge>
}

/** A stored URL as a link. The server only accepts http(s); this holds the line anyway. */
export function SafeExternalLink({ href }: { href: string }) {
  if (!/^https?:\/\//i.test(href)) return <span className="break-all">{href}</span>
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className="inline-flex max-w-full items-center gap-1 text-ink underline decoration-line-strong underline-offset-2 hover:text-accent">
      <span className="min-w-0 break-all">{href.replace(/^https?:\/\/(www\.)?/i, '').replace(/\/$/, '')}</span>
      <ExternalLinkIcon size={13} className="shrink-0 text-subtle" />
    </a>
  )
}

